import { useEffect } from "react";
import { Flex } from "@ir/ui";
import PageContent from "@/presentation/ui/layouts/page/PageContent";
import AnalyticsFilterReadOnly from "./components/AnalyticsFilterReadOnly";
import AnalyticsDashboardContent from "./AnalyticsDashboardContent";
import { useAtom, useAtomValue } from "jotai";
import { fetchAllSharedAnalyticsAtom } from "@/store/sharedAnalytics";
import { shareLinkDataAtom } from "@/store/shareLink";

const SharedAnalyticsPage = () => {
  const shareLink = useAtomValue(shareLinkDataAtom);
  const [, fetchAllSharedAnalytics] = useAtom(fetchAllSharedAnalyticsAtom);

  useEffect(() => {
    if (!shareLink) return;
    void fetchAllSharedAnalytics();
  }, [shareLink, fetchAllSharedAnalytics]);

  return (
    <>
      <Flex
        className="shared-analytics-filter-bar bg-white border-bottom-1 border-color-grey-25 px-4 py-2"
        style={{ position: "sticky", top: 0, zIndex: 1000 }}
      >
        <AnalyticsFilterReadOnly />
      </Flex>
      <PageContent className="shared-analytics-content p-4" style={{ overflowX: "hidden", overflowY: "auto" }}>
        <AnalyticsDashboardContent />
      </PageContent>
    </>
  );
};

export default SharedAnalyticsPage;
